import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Mail, Heart, Clock } from "lucide-react";
import { useApp } from "../context/AppContext";

const Footer = () => {
  const { settings, t, lang } = useApp();
  const waLink = settings?.whatsapp ? `https://wa.me/${settings.whatsapp.replace(/[^\d]/g, "")}` : "#";
  const igHandle = (settings?.instagram || "").replace("@", "");
  const igLink = igHandle ? `https://instagram.com/${igHandle}` : "#";
  const hours = (lang === "id" ? settings?.opening_hours_id : settings?.opening_hours_en) || "";
  return (
    <footer className="bg-holy-green text-ivory mt-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            {settings?.logo_url && (
              <img src={settings.logo_url} alt="Holy Flowy" className="h-14 w-14 rounded-full object-cover ring-2 ring-holy-gold/50" />
            )}
            <div>
              <div className="font-serif text-3xl">Holy Flowy</div>
              <div className="font-script text-holy-gold text-lg">handmade with love</div>
            </div>
          </div>
          <p className="text-ivory/80 max-w-md text-sm leading-relaxed whitespace-pre-line">
            {(lang === "id" ? (settings?.footer_text_id || settings?.about_id) : (settings?.footer_text_en || settings?.about_en)) || ""}
          </p>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-3 text-holy-gold">{t("nav_shop")}</h4>
          <ul className="space-y-2 text-sm text-ivory/80">
            {settings?.footer_links && settings.footer_links.filter((l) => l.active).length > 0 ? (
              settings.footer_links.filter((l) => l.active).sort((a, b) => a.order - b.order).map((l, i) => (
                <li key={i}><Link to={l.url} className="hover:text-holy-gold">{lang === "id" ? l.label_id : l.label_en}</Link></li>
              ))
            ) : (
              <>
                <li><Link to="/shop" className="hover:text-holy-gold">{t("all_products")}</Link></li>
                <li><Link to="/shop?cat=bouquet" className="hover:text-holy-gold">Bouquet</Link></li>
                <li><Link to="/shop?cat=tree" className="hover:text-holy-gold">Trees</Link></li>
                <li><Link to="/shop?cat=pick" className="hover:text-holy-gold">Picks</Link></li>
                <li><Link to="/about" className="hover:text-holy-gold">{t("nav_about")}</Link></li>
                <li><Link to="/admin/login" className="hover:text-holy-gold">{t("nav_admin")}</Link></li>
              </>
            )}
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg mb-3 text-holy-gold flex items-center gap-2">
            <Clock className="w-4 h-4" /> {lang === "id" ? "Jam Operasional" : "Opening Hours"}
          </h4>
          <div className="text-sm text-ivory/80 whitespace-pre-line leading-relaxed mb-5" data-testid="opening-hours">
            {hours}
          </div>
          <h4 className="font-serif text-lg mb-3 text-holy-gold">{t("follow_us")}</h4>
          <div className="flex gap-3">
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-wa"
              aria-label="WhatsApp"
              className="w-11 h-11 rounded-full bg-[#25D366] hover:bg-[#1ebe5d] flex items-center justify-center transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-5 h-5 text-white" />
            </a>
            <a
              href={igLink}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-ig"
              aria-label="Instagram"
              className="w-11 h-11 rounded-full bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#FCB045] hover:opacity-90 flex items-center justify-center transition-all hover:-translate-y-0.5"
            >
              <Instagram className="w-5 h-5 text-white" />
            </a>
            {settings?.email && (
              <a
                href={`mailto:${settings.email}`}
                data-testid="footer-mail"
                aria-label="Email"
                className="w-11 h-11 rounded-full bg-ivory/10 hover:bg-ivory/20 flex items-center justify-center transition-all hover:-translate-y-0.5"
              >
                <Mail className="w-5 h-5 text-ivory" />
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="border-t border-ivory/10 py-4 text-center text-xs text-ivory/60 font-sans tracking-wider">
        © {new Date().getFullYear()} Holy Flowy · Made <Heart className="inline w-3 h-3 text-holy-red fill-holy-red" /> in Indonesia
      </div>
    </footer>
  );
};

export default Footer;
